import { createAsyncThunk } from '@reduxjs/toolkit';

import { IPunchAssignmentsItemDTO } from 'src/api/dtos';
import PunchAssignmentRepository from 'src/api/repositories/ess/v1/punchAssignment.repository';

export const fetchPunchAssignments = createAsyncThunk<IPunchAssignmentsItemDTO[], void>(
  'punchAssignments',
  async (_, { rejectWithValue }) => {
    try {
      const repository = new PunchAssignmentRepository();
      return await repository.get();
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);
